import { useEffect } from 'react';

const FormikEffect = ({ values, onChange }: { values: any; onChange: (values: any) => void }) => {
  useEffect(() => {
    onChange(values);
  }, [values, onChange]);

  return null;
};

export default FormikEffect;
